<template>
  <v-data-table
    :headers="headers"
    :items="billing_reports"
    :pagination.sync="pagination"
    no-data-text="Nenhuma planilha encontrada."
  >
    <template v-slot:items="props">
      <td>
        {{ props.item && props.item.created_at | formatarDate }}
      </td>
      <td>{{ props.item.competence }}</td>
      <td>{{ props.item.power_plant_id }}</td>
      <td>
        <v-layout nowrap align-center justify-start>
          <v-flex md2>
            <v-icon @click="downloadFile(props.item.path)">download</v-icon>
          </v-flex>
          <v-flex md2>
            <v-tooltip bottom v-if="props.item.non_existing_ucs">
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="error"
                  v-on="on"
                  @click="copyUcs(props.item)"
                >
                  <v-icon>priority_high</v-icon>
                </v-btn>
              </template>
              <span
                >UCs não encontradas:
                {{ props.item.non_existing_ucs | arrayToString }}</span
              >
            </v-tooltip>
          </v-flex>
        </v-layout>
      </td>
    </template>

    <template v-slot:no-data v-if="loading">
      <div class="text-xs-center">
        Carregando tabela
        <v-progress-circular
          indeterminate
          color="#7C3DFF"
          size="17"
        ></v-progress-circular>
      </div>
    </template>

    <v-snackbar :color="snack.color" top v-model="snack.show" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.message }}</div>
      <v-icon size="16" @click="snack.show = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-data-table>
</template>

<script>
import { standardBucket } from "../../firebase/firestorageBank";
import { mapState, mapActions } from "vuex";

export default {
  name: "sheet-upload-list",

  data: () => ({
    headers: [
      { text: "Criado em", value: "created_at" },
      { text: "Competência", value: "competence" },
      { text: "Usina", value: "power_plant_id" },
      { text: "Planilha", value: "path" },
    ],
    pagination: {
      sortBy: "created_at",
      descending: true,
      rowsPerPage: 10,
    },
    snack: {
      show: false,
      color: "",
      message: "",
    },
  }),

  computed: {
    ...mapState("reports", ["loading", "billing_reports"]),
  },

  methods: {
    ...mapActions("reports", ["getBillingReports"]),

    downloadFile(path) {
      const resumeRef = standardBucket.ref(path);

      resumeRef
        .getDownloadURL()
        .then(async (url) => {
          window.open(url, "_blank");
        })
        .catch((error) => {
          switch (error.code) {
            case "storage/object-not-found":
              this.showSnackBar("Planilha não encontrada!", "red");
              break;

            case "storage/unauthorized":
              this.showSnackBar("Sem permissão para fazer o download", "red");
              break;
            default:
              break;
          }
        });
    },

    copyUcs(item) {
      let text = "";

      for (const uc of item.non_existing_ucs) {
        text += uc + "\n";
      }

      navigator.clipboard.writeText(text);
      this.showSnackBar("UCs copiadas para área de transferência", "green");
    },

    showSnackBar(message, color) {
      this.snack.color = color;
      this.snack.message = message;
      this.snack.show = true;
    },
  },

  filters: {
    arrayToString: (value) => {
      if (!value) return "";

      return value.toString();
    },
  },

  created() {
    if (this.billing_reports.length === 0) {
      const res = this.getBillingReports();
      if (res === 500) {
        this.showSnackBar("Erro ao buscar as planilhas", "red");
      }
    }
  },
};
</script>
